document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(`
    .as-heading-ultra-large,
    .as-heading-large,
    .as-heading-medium,
    .as-heading-small,
    .as-text,
    .as-badge-text,
    .as-eyebrow
  `);

  elements.forEach((el) => {
    el.classList.add("as-animate");
  });

  const showElement = (el) => {
    el.classList.add("is-visible");
  };

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        showElement(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.1,
      rootMargin: "0px 0px -30px 0px",
    },
  );

  setTimeout(() => {
    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

      if (isInViewport) {
        showElement(el);
      } else {
        observer.observe(el);
      }
    });
  }, 100);
});
